import { useEffect, useState } from "react";
import { apiOAuthProviders } from "./api";

export function useOAuthProviders() {
  const [google, setGoogle] = useState(false);
  const [apple, setApple] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    apiOAuthProviders()
      .then((p) => {
        if (!cancelled) {
          setGoogle(p.google);
          setApple(p.apple);
        }
      })
      .catch((e: unknown) => {
        if (!cancelled) {
          setError(e instanceof Error ? e.message : "Could not load sign-in options");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { google, apple, loading, error };
}
